import React, { PropTypes } from 'react'

import BigBreadcrumbs from '../layout/navigation/components/BigBreadcrumbs.jsx'
import WidgetGrid from '../layout/widgets/WidgetGrid.jsx'
import JarvisWidget from '../layout/widgets/JarvisWidget.jsx'

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { Button } from 'react-bootstrap';
import styles from 'react-bootstrap-table/dist/react-bootstrap-table.min.css';

class ContractTable extends React.Component{

  idFormatter(cell, row) {
      if (row.is_top)
          return pad(cell, 6);
  }
  iconUrlFormatter(cell, row) {
      return `<img src=\"${cell}\" width=\"42\" height=\"42\">`;
  }
  updateDateFormatter(cell, row) {

      if(row.is_top==1)
          return formatDate(new Date(row.created_at), 'YYYY年MM月DD日 hh:mm:ss');
      else
          return formatDate(new Date(row.reply_updated_at), 'YYYY年MM月DD日 hh:mm:ss');
  }
  statusFormatter(cell, row) {

    var messageId = row.message_id;
    var isTop = row.is_top == '1'?true:false;

    if (row.status === 0) {
        return <Button type="button" bsStyle="primary" onClick={()=>{this.props.onClickApproveButton(messageId, isTop)}}>承認</Button>
    } else {
        return '承認済';
    }

  }
  replyFormatter(cell, row) {

    var messageId = row.message_id;

    if (row.is_top) {
        return <Button type="button" bsStyle="primary" onClick={() => this.props.onClickReplyButton(messageId)}>返信</Button>
    }

  }
  render(){

    return <div id="content">
        <div className="row">
            <BigBreadcrumbs items={['Table', 'Data Tables']} icon="table" className="col-xs-12 col-sm-7 col-md-7 col-lg-4" />
        </div>

        <WidgetGrid>

            <div className="row">
                <article className="col-sm-12">

                    <JarvisWidget editbutton={false} color="darken" >
                        <header>
                            <span className="widget-icon">
                                <i className="fa fa-table" />
                            </span>
                            <h2>意見リスト</h2>
                        </header>
                        <div>
                            <div className="widget-body no-padding">

                              <BootstrapTable
                                  data={this.props.posts}
                                  options={{sizePerPage: 15}}
                                  pagination
                                  >
                                  <TableHeaderColumn dataField='id' isKey hidden>ID</TableHeaderColumn>
                                  <TableHeaderColumn dataField='top_id' width='70px' dataFormat={this.idFormatter}>ID</TableHeaderColumn>
                                  <TableHeaderColumn dataField='nick_name' width='160px'>ニックネーム</TableHeaderColumn>
                                  <TableHeaderColumn dataField='icon_url' dataFormat={this.iconUrlFormatter} width='70px'>アイコン</TableHeaderColumn>
                                  <TableHeaderColumn dataField='message' columnClassName='td-column-wrap'>投稿内容</TableHeaderColumn>
                                  <TableHeaderColumn dataField='updated_at' dataFormat={this.updateDateFormatter} width='180px'>日時</TableHeaderColumn>
                                  <TableHeaderColumn dataField='status' dataFormat={this.statusFormatter.bind(this)} width='90px'>ステータス</TableHeaderColumn>
                                  <TableHeaderColumn dataFormat={this.replyFormatter.bind(this)} width='70px'>回答</TableHeaderColumn>
                              </BootstrapTable>

                            </div>
                        </div>
                    </JarvisWidget>
                </article>

            </div>

        </WidgetGrid>

    </div>
  }
}

ContractTable.propTypes = {
  posts: PropTypes.array.isRequired,
  onClickApproveButton: PropTypes.func.isRequired,
  onClickReplyButton: PropTypes.func.isRequired
}

function pad(n, width, z) {
    z = z || '0';
    n = n + '';
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
}

var formatDate = function(date, format) {
    if (!format)
        format = 'YYYY-MM-DD hh:mm:ss.SSS';
    format = format.replace(/YYYY/g, date.getFullYear());
    format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
    format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
    format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
    format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
    format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
    if (format.match(/S/g)) {
        var milliSeconds = ('00' + date.getMilliseconds()).slice(-3);
        var length = format.match(/S/g).length;
        for (var i = 0; i < length; i++)
            format = format.replace(/S/, milliSeconds.substring(i, i + 1));
    }
    return format;
};

export default ContractTable;



// WEBPACK FOOTER //
// ./src/components/contract/ContractTable.js